<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Artikelverkäufe &amp; Retouren</h3>
            <div class="box-tools pull-right" title="Details einblenden">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
            <!-- /.box-tools -->
          </div>
          <!-- /.box-header -->
          <div class="box-controls">
            <div class="row">
              <multiselect v-model="company" :options="companies" :placeholder="'select_one' | translate" label="name" track-by="id" @input="getData()"></multiselect>
              <hr>
            </div>
            <div class="btn-group">
              <button type="button" data-toggle="collapse" data-target="#coll1" aria-expanded="true" aria-controls="coll1" class="btn btn-default btn-sm"><i class="fa fa-sort mr-5"></i>{{'show_hide_filters' | translate}}</button>
            </div>
            <my-pagination :lang="$store.getters.language" :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
            <div class="row">
              <div class="col-xs-12">
                <div id="coll1" :class="company.id === 0 ? 'collapse' : 'collapse in'" aria-expanded="true" style="">
                  <div class="pt-10 row">
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group"><input @keyup.13.prevent="paginate" @blur=paginate type="text" name="search" :placeholder="'search_brand' | translate" class="form-control" v-model="filters.brand"> <div class="input-group-btn"><button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button></div></div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group"><input @keyup.13.prevent="paginate" @blur=paginate type="text" name="search" :placeholder="'search_producer_model' | translate" class="form-control" v-model="filters.producer_model"> <div class="input-group-btn"><button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button></div></div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group"><input @keyup.13.prevent="paginate" @blur=paginate type="text" name="search" :placeholder="'search_WWS' | translate" class="form-control" v-model="filters.wws_number"> <div class="input-group-btn"><button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button></div></div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><input @keyup.13.prevent="paginate" @blur=paginate type="text" name="search" :placeholder="'search_item' | translate" class="form-control" v-model="filters.wws_model"> <div class="input-group-btn"><button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button></div></div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><input @keyup.13.prevent="paginate" @blur=paginate type="text" name="search" :placeholder="'search_image' | translate" class="form-control" v-model="filters.img_id"> <div class="input-group-btn"><button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button></div></div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'return_rate' | translate}}<i class="fa fa-caret-up ml-5"></i> </div>
                        <select class="form-control" v-model="filters.return_rate_bigger" @change="paginate">
                          <option class="normal" value="0">{{'all' | translate}}</option>
                          <option class="normal" value="10">{{'greater_than' | translate}} 10%</option>
                          <option class="normal" value="20">{{'greater_than' | translate}} 20%</option>
                          <option class="normal" value="30">{{'greater_than' | translate}} 30%</option>
                          <option class="normal" value="40">{{'greater_than' | translate}} 40%</option>
                          <option class="normal" value="50">{{'greater_than' | translate}} 50%</option>
                          <option class="normal" value="60">{{'greater_than' | translate}} 60%</option>
                          <option class="normal" value="70">{{'greater_than' | translate}} 70%</option>
                          <option class="normal" value="80">{{'greater_than' | translate}} 80%</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'return_rate' | translate}}<i class="fa fa-caret-down ml-5"></i></div>
                        <select class="form-control" v-model="filters.return_rate_lower" @change="paginate">
                          <option class="normal" value="0">{{'all' | translate}}</option>
                          <option class="normal" value="10">{{'smaller_than' | translate}} 10%</option>
                          <option class="normal" value="20">{{'smaller_than' | translate}} 20%</option>
                          <option class="normal" value="30">{{'smaller_than' | translate}} 30%</option>
                          <option class="normal" value="40">{{'smaller_than' | translate}} 40%</option>
                          <option class="normal" value="50">{{'smaller_than' | translate}} 50%</option>
                          <option class="normal" value="60">{{'smaller_than' | translate}} 60%</option>
                          <option class="normal" value="70">{{'smaller_than' | translate}} 70%</option>
                          <option class="normal" value="80">{{'smaller_than' | translate}} 80%</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'price_rate' | translate}}<i class="fa fa-caret-up ml-5"></i> </div>
                        <input @keyup.13.prevent="paginate" @blur="paginate" type="number" name="search" class="form-control" v-model="filters.products_price_bigger"/>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'price_rate' | translate}}<i class="fa fa-caret-down ml-5"></i></div>
                        <input @keyup.13.prevent="paginate" @blur="paginate" type="number" name="search" class="form-control" v-model="filters.products_price_lower"/>
                      </div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'total_sales_f' | translate}}<i class="fa fa-caret-up ml-5"></i> </div>
                        <input @keyup.13.prevent="paginate" @blur="paginate" type="number" name="search" class="form-control" v-model="filters.total_sales_bigger"/>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'total_sales_f' | translate}}<i class="fa fa-caret-down ml-5"></i></div>
                        <input @keyup.13.prevent="paginate" @blur="paginate" type="number" name="search" class="form-control" v-model="filters.total_sales_lower"/>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'stock_company' | translate}}<i class="fa fa-caret-up ml-5"></i> </div>
                        <input @keyup.13.prevent="paginate" @blur="paginate" type="number" name="search" class="form-control" v-model="filters.stock_company_bigger"/>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'season' | translate}}</div>
                        <multiselect v-model="filters.seasons" :options="multiselectSeasons" :close-on-select="false" :clear-on-select="false" :hide-selected="true" :placeholder="'select_multiple' | translate"   @input="paginate()" :multiple="true"></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="pt-10 row">
                    <div class="col-md-3 col-sm-6">
                      <div class="input-group"><div class="input-group-addon">{{'status' | translate}}</div>
                        <multiselect v-model="filters.marketplaces" :options="mps" :close-on-select="false" :clear-on-select="false" :hide-selected="true" :placeholder="'select_multiple' | translate" label="name" track-by="status" @input="paginate()" :multiple="true">
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12">
                      <b-btn @click="clear" type="button" class="btn btn btn-sm btn-warning"><i class="fa fa-undo mr-5"></i>{{'reset_filters' | translate}}</b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="company.id === 0" class="box-body">
              <div class="callout callout-info">
                <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
                <p>Es sind keine Statistiken vorhanden. Bitte wählen Sie ein Unternehmen</p>
              </div>
            </div>
          <div v-else class="box-body">
            <template v-if="loading">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <img class="loading-gif" src="/static/img/blabla.svg"/>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{'image' | translate}}</th>
                  <th>{{'model' | translate}}</th>
                  <th class="is-clickable">{{'prices' | translate}}</th>
                  <th>{{'sales' | translate}}</th>
                  <th>{{'returns' | translate}}</th>
                  <th class="is-clickable" @click="getState('sort_return_rate', filters.sort_return_rate)"><i :class="[filters.sort_return_rate === '' ? 'fa fa-sort' : 'fa fa-sort-' + filters.sort_return_rate, 'mr-5']"></i>{{'return_rate' | translate}}</th>
                  <th class="is-clickable" @click="getState('sort_stock_company', filters.sort_stock_company)"><i :class="[filters.sort_stock_company === '' ? 'fa fa-sort' : 'fa fa-sort-' + filters.sort_stock_company, 'mr-5']"></i>{{'stock_company' | translate}}</th>
                  <th class="is-clickable" @click="getState('sort_products_price', filters.sort_products_price)"><i :class="[filters.sort_products_price === '' ? 'fa fa-sort' : 'fa fa-sort-' + filters.sort_products_price, 'mr-5']"></i>{{'price_rate' | translate}}</th>
                  <th>{{'details' | translate}}</th>
                  <th width="15%">{{'status' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in pagination.data">
                  <tr>
                    <td>
                      <a href="#">
                        <img :src="item.img_path" class="img-preview">
                      </a>
                    </td>
                    <td style="width:20%">
                      <strong>{{item.title}}</strong><br>
                      <small class="text-muted">{{'brand' | translate}}: {{item.brand}}</small><br>
                      <small class="text-muted">{{'image' | translate}} ID: {{item.img_id}}</small><br>
                      <small class="text-muted">ERP ID: {{item.wws_number}}</small><br>
                      <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small><br/>
                      <small class="text-muted">{{'producer_model' | translate}}: {{item.producer_model}}</small><br/>
                      <small class="text-muted">{{'season' | translate}}: {{item.season}}</small>
                    </td>
                    <td>
                      <ul class="list-unstyled small" v-if="typeof item.prices !== 'undefined'">
                        <li v-for="mp in getChannels(item.prices)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                          {{mp.name | translate}}: Ø {{mp.value | currency}}
                        </li>
                      </ul>
                      <strong class="text-muted">Ø-{{'price' | translate}}: {{item.price_rate | currency}}</strong>
                    </td>
                    <td>
                      <ul class="list-unstyled small" v-if="typeof item.sales !== 'undefined'">
                        <li v-for="mp in getChannels(item.sales)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                          {{mp.name | translate}}: {{mp.value}}
                        </li>
                      </ul>
                      <strong class="text-muted">{{'amount' | translate}}: {{item.sales.total}}</strong>
                    </td>
                    <td>
                      <ul  v-if="typeof item.returns !== 'undefined'" class="list-unstyled small">
                        <li v-for="mp in getChannels(item.returns)"><i :class="['fa', getIcon(mp.name), 'mr-5']"></i>
                          {{mp.name | translate}}: {{mp.value}}
                        </li>
                      </ul>
                      <strong class="text-muted">{{'amount' | translate}}: {{item.returns.total}}</strong>
                    </td>
                    <td>
                      <p><strong :class="`text-${item.pct.style}`"><i :class="item.pct.icon"></i>{{item.pct.val| currency('%')}}</strong></p>
                      <div class="progress xs no-margin">
                        <div :class="`progress-bar progress-bar-${item.pct.style}`" :style="`width: ${item.pct.val}%`"></div>
                      </div>
                    </td>
                    <td>
                      {{item.stock_company}}
                    </td>
                    <td>
                      {{item.products_price | currency}}
                    </td>
                    <td>
                      <router-link :to="`/products/${company.id}/${item.wws_model}`"><button class="btn btn-info btn-flat">{{'details' | translate}}</button></router-link>
                    </td>
                    <td>
                      <template v-for="channel in item.channels">
                        <product-channel :channel="channel" :model="item.wws_model" :key="`${item.id}-${channel.name}`" @pushAlert="toggleChannel($event, item)" :company="company.id"></product-channel>
                      </template>
                      <!--<button v-for="channel in item.channels" type="button" @click="activate(item, [{name: channel.name, active: !channel.active}])" :class="[channel.active ? 'btn btn-success btn-sm mr-5 active' : 'btn btn-danger btn-sm active mr-5']">
                        <i :class="[channel.active ? 'fa fa-check mr-5' : 'fa fa-ban mr-5']"></i>{{channel.name | translate}}</button>
                    --></td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
            </template>
          </div>
          <!-- /.box-body -->
          <div class="box-footer">
            <div class="row">
              <my-pagination :lang="$store.getters.language" :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
            </div>
          </div>
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
  </section>
</template>

<script>

export default {
  name: 'Statistics',
  data () {
    return {
      loading: false,
	    mps: [
		    { status: 'amazon', name: 'Amazon - active', amazon: true },
		    { status: 'amazon', name: 'Amazon - inactive', amazon: false },
		    { status: 'ebay', name: 'eBay - active', ebay: true },
		    { status: 'ebay', name: 'eBay - inactive', ebay: false },
		    { status: 'zalando', name: 'Zalando - active', zalando: true },
		    { status: 'zalando', name: 'Zalando - inactive', zalando: false },
		    { status: 'spartoo', name: 'Spartoo - active', spartoo: true },
		    { status: 'spartoo', name: 'Spartoo - inactive', spartoo: false },
	      { status: 'tamaris', name: 'Tamaris - active', tamaris: true },
        { status: 'tamaris', name: 'Tamaris - inactive', tamaris: false },
        { status: 'mirapodo', name: 'Mirapodo - active', mirapodo: true },
        { status: 'mirapodo', name: 'Mirapodo - inactive', mirapodo: false },
        { status: 'check24', name: 'Check24 - active', check24: true },
        { status: 'check24', name: 'Check24 - inactive', check24: false }
      ],
      multiselectSeasons: [],
	    filters: {
		    wws_model: '',
		    wws_number: '',
		    producer_model: '',
		    img_id: '',
		    brand: '',
		    return_rate_bigger: 0,
		    return_rate_lower: 0,
		    products_price_bigger: 0,
		    products_price_lower: 0,
		    total_sales_bigger: 0,
		    total_sales_lower: 0,
		    marketplaces: [],
        sort_return_rate: '',
        sort_products_price: '',
        sort_stock_company: '',
        stock_company_lower: 0,
        stock_company_bigger: 1,
        seasons: []
	    },
    	companies:[],
      company: {
	      id: 0,
	      name: 'Wählen Sie ein Unternehmen aus'
      },
	    pagination: {
		    total: 0,
		    per_page: 25,
		    current_page: 1,
		    total_pages: 0
	    },
    }
  },
  computed: {
  },
  methods: {
	  clear () {
		  this.filters = {
			  wws_model: '',
			  wws_number: '',
			  img_id: '',
			  marketplaces: [],
			  brand: '',
			  return_rate_bigger: 0,
			  return_rate_lower: 0,
			  products_price_bigger: 0,
			  products_price_lower: 0,
			  total_sales_bigger: 0,
			  total_sales_lower: 0,
        sort_return_rate: '',
        sort_products_price: '',
        sort_stock_company: '',
        stock_company_bigger: 1,
        stock_company_lower: 0,
        seasons: []
		  }
		  this.paginate('', '')
	  },
	  getState (obj, state) {

      this.multiselectSeasons=[]
      this.clear()
		  if (state === '') {
			  state = 'asc'
		  } else if (state === 'asc') {
			  state = 'desc'
		  } else {
			  state = ''
		  }

		  this.filters[obj] = state
		  this.paginate('sort', '')
	  },
    loadFilters() {

      API.get(`statistics/products/${this.company.id}/filters`)
        .then(response => {
          this.multiselectSeasons = response.data.season
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
        });
    },
	  paginate (type, value) {
		  let url = '?'
		  let fs = Object.keys(this.filters)
		  fs.forEach(f => {
			  if (f === 'marketplaces') {
				  let channels = {}
				  this.filters[f].forEach(mp => {
					  channels[mp.status] = mp[mp.status]
				  })
				  url += `channels=${JSON.stringify(channels)}&`
			  }
			  else if (f === 'seasons') {
          url += `seasons=${JSON.stringify(this.filters.seasons)}&`
        }
			  else if (f === 'products_price_bigger' || f === 'products_price_lower') {
			    url += `${f}=${this.filters[f].toString().replace(',', '.')}&`
        }
			  else{
            url += `${f}=${this.filters[f]}&`
        }
		  })
      url = url.substring(0, url.length -1)
		  if (type === 'page') {
			  url += '&page='
			  if (value === 'previous') {
				  url += (this.pagination.current_page - 1)
			  }
			  if (value === 'next') {
				  url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
			  } else if (value !== 'next' && value !== 'previous') {
				  url += value
			  }
		  }
      this.loadFilters()
      API.get(`statistics/products/${this.company.id}${url}`)
			  .then(response => {
				  this.pagination = response.data
          this.pagination.data.forEach(i => {
	          let total = i.return_rate
            i.pct = {
              style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
          })
			  })
        .catch(error => {
			  this.$store.dispatch('checkError', error)
		  })
	  },
  	getIcon (mp) {
  		return mp === 'schuhede' ? 'fa-schuhe' : `fa-${mp}`
    },
    getChannels (item) {
	  	return [
			  {
				  name: 'schuhede',
				  value: typeof item.schuhede !== 'undefined' ? item.schuhede : 0
			  },
			  {
				  name: 'zalando',
				  value: typeof item.zalando !== 'undefined' ? item.zalando : 0
			  },
			  {
				  name: 'amazon',
				  value: typeof item.amazon !== 'undefined' ? item.amazon : 0
			  },
			  {
				  name: 'ebay',
				  value: typeof item.ebay !== 'undefined' ? item.ebay : 0
			  },
			  {
				  name: 'spartoo',
				  value: typeof item.spartoo !== 'undefined' ? item.spartoo : 0
			  },
        {
          name: 'mirapodo',
          value: typeof item.mirapodo !== 'undefined' ? item.mirapodo : 0
        },
        {
          name: 'tamaris',
          value: typeof item.tamaris !== 'undefined' ? item.tamaris : 0
        }
		  ]
    },
	  getData () {
      this.clear()
	    this.loadFilters();
	    this.loading = true
		  API.get(`statistics/products/${this.company.id}?stock_company_bigger=${this.filters.stock_company_bigger}`)
			  .then(res => {
			    this.loading = false
				  this.pagination = res.data
          this.pagination.data.forEach(i => {
	          let total = i.return_rate
          	i.pct = {
          		style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
          })
			  })
			  .catch(error => {
			    this.loading = false
				  console.log(error)
			  })
	  },
    toggleChannel (value, item) {
      let tog = item.channels.find(x => x.name === value.channel)
      tog.active = value.active
      // this.alerts.push({type: 'danger', dismiss: 4, message: 'Error!'})
      /* API.put('inventory/' + item.wws_model, {channels: channels})
        .then(res => {
          if (channels.length > 0) {
            let index = this.pagination.data.findIndex(e => {
              return e.wws_model === item.wws_model
            })
            this.pagination.data[index].channels.find(a => { return a.name === channels[0].name }).active = channels[0].active
            this.pagination.data = [...this.pagination.data]
            this.alerts.push({type: 'success', dismiss: 4, message: 'Success!'})
          }
        })
        .catch(error => {
          this.alerts.push({type: 'danger', dismiss: 4, message: 'Error!'})
        }) */
    },
    pushAlertMessage (alert) {
      this.alerts.push(alert)
      this.loading = true
      API.get('inventory' + this.filterUrl)
        .then(response => {
          this.pagination = response.data
          this.filteredProducts = Object.assign({}, this.pagination.data)

          this.pagination.data.forEach(i => {
            let total = i.return_rate
            i.pct = {
              style: total <= 40 ? 'success' : total >= 80 ? 'danger' : 'warning',
              icon: total <= 40 ? 'fa fa-check mr-5' : total >= 80 ? 'fa fa-flash mr-5' : 'fa fa-warning mr-5',
              val: total
            }
            i.showChannels = true
          })
          this.loading = false
        })
        .catch(error => {
          this.$store.dispatch('checkError', error)
          this.loading = false
        })
    },
  },
  mounted () {
	  this.companies = this.$store.getters.companies
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect::placeholder {
    color: #ffffff !important;
  }
</style>
<style>
  .is-clickable {
    cursor: pointer;
  }
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
 </style>
<style>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }

</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Statistics/ProductStatistics.vue